import { render, staticRenderFns } from "./OverviewWiki.vue?vue&type=template&id=ec723f3e&scoped=true&"
import script from "./OverviewWiki.vue?vue&type=script&lang=ts&"
export * from "./OverviewWiki.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewWiki.vue?vue&type=style&index=0&id=ec723f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec723f3e",
  null
  
)

export default component.exports